<script setup lang="ts">
import type { NovaModalTermProps } from './NovaModalTerm.types'

defineProps<NovaModalTermProps>()
</script>

<template>
  <div v-dompurify-html="termDetail" class="term-wrap" />
</template>

<style lang="scss" scoped>
.term-wrap {
  padding: 10px;

  :deep(.terms_box_list) {
    > li {
      padding-top: 20px;

      &:first-child {
        padding-top: 0;
      }

      dl {
        dt {
          padding-bottom: 5px;
          @include text-style($text-display-medium);
        }
        dd {
          @include text-style($text-body-14-regular);
          ul {
            padding-top: 5px;
            padding-left: 0;
            li {
              padding-top: 10px;
              padding-left: 16px;
              text-indent: -16px;

              &:first-child {
                padding-top: 0;
              }
            }
          }
          table {
            width: 100%;
            table-layout: fixed;
            border: 1px solid #154f65;
            th {
              padding: 10px;
              color: #fff;
              text-align: center;
              background: #8d8d8d;
              vertical-align: middle;
              border: 1px solid #154f65;
            }
            td {
              padding: 10px;
              text-align: center;
              vertical-align: middle;
              border: 1px solid #154f65;
            }
          }
          div {
            padding: 10px 0;
          }
        }
      }
    }
    & + p {
      padding-top: 10px;
      @include text-style($text-body-13-regular);
    }
    & + p + p {
      padding-top: 10px;
      @include text-style($text-body-13-regular);
    }
  }
}
</style>
